module.exports = __webpack_public_path__ + "static/media/calendar.92029da3.svg";